import Vue from 'vue'
import Vuex from 'vuex'
import tagsView from './tagsView'
import getters from './getters'
import app from './app'
import permission from './permission'
import user from './user'

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    tagsView,
    app,
    permission,
    user
  },
  getters
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js